import { locales } from "./locales";
import { z } from "zod";

// good enough for now, no need for regex
export const zodTuid = () => z.string().length(36);

export const zodCustomProps = () => z.record(z.any());

export const zodLocales = z.enum(locales).default("RO");

export const zodLocalizedNameObject = () =>
  z
    .record(zodLocales, z.string())
    .refine((value) => Object.keys(value).length > 0, {
      message: "At least one locale is required",
    })
    .refine((value) => Object.keys(value).includes("RO"), {
      message: "RO locale is required",
    });
